import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { filter_Auction } from "../../../redux/action/auctionEvent";
import {
  NoItemsLeftInTable,
  catalogueStatus,
  convertTo12HourFormat,
  handleDateSetUp,
} from "../../../helpers/helpers";
import Paginations from "../../commanPage/pagination/Paginations";
import useFilteredEvents from "../../../helpers/filterEvents";
import CommonTableLoader from "../../loader/CommonTableLoader";

function UpcommingAuctionTable({ searchData, auctionFilter }) {
  const totalNumberRow = 30;
  const isLaptop = useMediaQuery({ query: "(max-width: 1550px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageVisited, setMaxPageVisited] = useState(1);
  const { filterAuctionData } = useSelector((pre) => pre?.filterAuction);
  const { loading } = useSelector((pre) => pre.loading);
  const [upcommingAuctions, setUpcommingAuctions] = useState([]);
  const [initialUpcommingAuction, setInitialUpcommingAuction] = useState([]);
  const filteredEvents = useFilteredEvents(initialUpcommingAuction, searchData);

  useEffect(() => {
    dispatch(
      filter_Auction("upcoming", currentPage, totalNumberRow, auctionFilter)
    );
  }, [dispatch, auctionFilter, currentPage, totalNumberRow]);

  useEffect(() => {
    if (filterAuctionData) {
      setUpcommingAuctions(filterAuctionData);
      setInitialUpcommingAuction(filterAuctionData); // Maintain a copy of the initial data
    }
  }, [filterAuctionData]);

  useEffect(() => {
    setUpcommingAuctions(filteredEvents);
  }, [filteredEvents]);

  useEffect(() => {
    setMaxPageVisited(1);
    setCurrentPage(1);
  }, [auctionFilter]);

  const memoizedUpcommingAuctions = useMemo(
    () => upcommingAuctions,
    [upcommingAuctions]
  );

  if (loading) {
    return <CommonTableLoader />;
  }
  return (
    <>
      <div className="table-container-style">
        {memoizedUpcommingAuctions?.length === 0 && searchData !== "" ? (
          <NoItemsLeftInTable />
        ) : (
          <table
            className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
              }`}
          >
            <thead className="grey lighten-3">
              <tr>
                <th style={{ width: !isLaptop && "350px" }}>Auction ID</th>
                <th>Auction Region</th>
                <th>Description</th>
                <th>Date/Timings</th>
                <th>Catalogue status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {memoizedUpcommingAuctions?.map((items) => (
                <TableRow
                  key={items?.auctionId}
                  item={items}
                  isTablet={isTablet}
                  navigate={navigate}
                  location={location}
                  isLaptop={isLaptop}
                />
              ))}
            </tbody>
          </table>
        )}
        {memoizedUpcommingAuctions?.length === 0 && searchData === "" && (
          <NoItemsLeftInTable />
        )}
      </div>
      {memoizedUpcommingAuctions?.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalNumberRow={totalNumberRow}
          totalData={memoizedUpcommingAuctions?.length}
          maxPageVisited={maxPageVisited}
          setMaxPageVisited={setMaxPageVisited}
        />
      )}
    </>
  );
}

const TableRow = ({ item, isTablet, navigate, location, isLaptop }) => (
  <tr>
    <td
      className={`${!isLaptop && "valign-wrapper justify-center"
        }`}
      style={{ width: !isLaptop && "350px" }}
    >
      <p>{item?.auctionId}</p>
      <p>
        {item?.location?.state && !isLaptop
          ? ` - ${item.location.state}`
          : item.location.state}
      </p>
    </td>
    <td>{item?.auctionRegion || "..."}</td>
    <td style={{ width: !isTablet ? "250px" : "auto" }}>
      <span className="NoOfline" style={{ WebkitLineClamp: 1 }}>
        {item?.description || "..."}
      </span>
    </td>
    <td>
      <p>
        {handleDateSetUp(item?.auctionSchedule?.startDate)}
      </p>
      <p>
        {convertTo12HourFormat(
          item?.auctionSchedule?.startingTime
        )}{" "}
        to{" "}
        {convertTo12HourFormat(
          item?.auctionSchedule?.endingTime
        )}
      </p>
    </td>
    <td
      className={`${item?.catalogue?.industryApproval?.status === "approval"
        ? "green-text"
        : item?.catalogue?.industryApproval?.status === "notApproval"
          ? "red-text"
          : "orange-text"
        }`}
      style={{ width: !isTablet && "150px" }}
    >
      <span>
        {catalogueStatus(item?.catalogue?.industryApproval?.status)}
      </span>
    </td>
    <td>
      <span
        className="material-icons  cercle-purple-text  pointer"
        onClick={() => {
          if (item?.auctionType === "reverseAuctionProduct") {
            navigate(
              `/product-reverse-auction/single-auction/${item?._id}`
            );
          } else if (
            item?.auctionType === "reverseAuctionService"
          ) {
            navigate(
              `/service-reverse-auction/single-auction/${item?._id}`
            );
          } else {
            navigate(`/forward-auction/single-auction/${item?._id}`);
          }
          localStorage.setItem("pathurl", `${location.pathname}`);
        }}
      >
        visibility
      </span>
    </td>
  </tr>
);

export default UpcommingAuctionTable;
